import { combineReducers } from "redux";
import socketReducer from "./socketReducer";
import roomReducer from "./roomReducer";
import galleryReducer from "./galleryReducer";
import modalReducer from "./modalReducer";
import userReducer from "./userReducer";
import adminReducer from "./adminReducer";

const rootReducer = combineReducers({
  socket: socketReducer,
  room: roomReducer,
  gallery: galleryReducer,
  modal: modalReducer,
  user: userReducer,
  admin: adminReducer,
});

export default rootReducer;
